import { Field, FieldRenderProps } from "@progress/kendo-react-form";
import {
    SetWorkstream,
    SetEffort,
    SetStartDate,
    SetEndDate,
    SetWorkstreamAssignment
} from "../../slices/TicketSlice";
import WorkstreamList from "./WorkstreamList";
import { useReduxDispatch, useReduxSelector } from "../../redux/hooks";
import { IWorkstream } from "../../types/Gameplan/IWorkstream";
import Time from "../Common/Time";
import { DatePicker, DateTimePicker } from "@progress/kendo-react-dateinputs";
import WorkstreamAssignment from "./WorkstreamAssignment";
import { Hint } from "@progress/kendo-react-labels";
import { toDigital } from "../../utils/utils";
import { IProject } from "../../types/Project/IProject";
import { TimeField } from "../CustomForms/FieldTypes/TimeField";

const TicketWorkstream = ({ selectedProject }: { selectedProject: IProject }) => {
    const dispatch = useReduxDispatch();
    const { WorkstreamId, Workstream_Assignment, WorkstreamName, Effort_Mins, Start_Date, End_Date, Project_Id, Project_Available_Time } = useReduxSelector(
        (state) => state.newTicket.ticket
    );
    const projectTimeRemaining = selectedProject?.Available_Time - (Effort_Mins | 0);

    return (<>
        {/* <div className='inline-block w-1/2 sm:w-1/2 sm:pl-3'>
            <Field
                id={"workstreamAssignment"}
                name={"workstreamAssignment"}
                label={"Assigned To"}
                onChange={(e) => SetWorkstreamAssignment(e.value)}
                component={WorkstreamAssignment}
                staff={Workstream_Assignment} />
        </div> */}
        <div className='inline-block w-1/2 sm:w-1/2 sm:pl-3 align-top'>
            <Field
                id={"workstream"}
                name={"workstream"}
                label={"workstream"}
                component={WorkstreamList}
                onChange={e => dispatch(SetWorkstream(e.value))}
                projectId={Project_Id}
                required={true}
                value={{ Workstream_Id: WorkstreamId, Workstream_Name: WorkstreamName } as IWorkstream} />
        </div>
        <div className='inline-block w-1/2 sm:w-1/4 sm:pl-3'>
            <div>
                <label className='k-label'>Start</label>
                <Field
                    id={"workstreamStart"}
                    name={"workstreamStart"}
                    // label={"Start"}
                    required={true}
                    showValidationMessage={true}
                    onChange={(e) => {
                        console.log('start date changed', e.value)
                        dispatch(SetStartDate(e.value))
                    }}
                    component={DatePicker}
                    value={Start_Date} />
            </div>
            <div>
                <label className='k-label'>End</label>
                <Field
                    id={"workstreamEnd"}
                    name={"workstreamEnd"}
                    // label={"End"}
                    required={true}
                    showValidationMessage={true}
                    onChange={(e) => dispatch(SetEndDate(e.value))}
                    component={DatePicker}
                    value={End_Date} />

            </div>
            <div>
                <Field
                    id={"effort"}
                    name={"effort"}
                    label={"Effort"}
                    component={Time}
                    mins={Effort_Mins}
                    onChange={(e) => e.value && dispatch(SetEffort(e.value))}
                /> hrs / <span className={projectTimeRemaining > 0 ? 'k-text-success' : 'k-text-error'}>{toDigital(projectTimeRemaining, true)} {projectTimeRemaining > 0 ? 'remaining' : 'over'}</span>
            </div>
        </div>
    </>)
}

export default TicketWorkstream;